<script setup lang="ts">
import { computed, type PropType, ref, watchEffect } from 'vue'
import type { InventoryMapObjectTypes } from '@/widgets/InventoryMap/model/types.ts'
import { DefaultMarker, PointMarker } from '@/entities/Inventory/Main'
import { isPoint, resolveFigureGeomType } from '@/features/Inventory/ObjectCreate/model/helpers.ts'

const props = defineProps({
  position: {
    type: Array as PropType<number[]>,
    default: () => [0, 0],
  },
  type: {
    type: Object as PropType<InventoryMapObjectTypes | null>,
    default: false,
  },
})

const pointer = ref()

/* Обновляем позицию элемента */
watchEffect(() => {
  if (!pointer.value) return

  pointer.value.style.top = props.position[1] + 'px'
  pointer.value.style.left = props.position[0] + 'px'
})

/* Вычисляем стили для маркера */
const styles = computed(() => {
  return {
    ...props.type?.styles,
    stroke: [props.type?.styles.stroke],
  }
})
</script>

<template>
  <div v-if="!!type" ref="pointer" class="w-invent-map__pointer">
    <DefaultMarker v-if="!isPoint(resolveFigureGeomType(type?.figure))" :style="styles" />
    <PointMarker v-else :subtype="type?.figure?.geom_subtype ?? 'square'" :style="styles" />
  </div>
</template>
